const MODULE = document.querySelectorAll(
    '[data-module="clientes_section"]'
);

class ClientesSection {
    constructor(component) {
        this.component = component;
        this.viewport = component.querySelector('[data-clients-viewport]');
        this.track = component.querySelector('[data-clients-track]');
        this.lists = [
            ...component.querySelectorAll('[data-clients-list]'),
        ];

        if (
            !this.viewport ||
            !this.track ||
            this.lists.length !== 2 ||
            component.dataset.marqueeInitialized
        ) {
            return;
        }

        this.items = [...this.lists[0].children];

        if (!this.items.length) {
            return;
        }

        component.dataset.marqueeInitialized = 'true';
        this.speed = 40;
        this.distance = 0;
        this.position = 0;
        this.reducedMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
        );
        this.update = this.update.bind(this);
        this.viewport.addEventListener('focus', this.update);
        this.viewport.addEventListener('blur', this.update);
        this.update();

        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.lists[0]);
        this.reducedMotion.addEventListener('change', this.update);

        this.items.forEach((item) => {
            item.querySelectorAll('img').forEach((image) => {
                image.addEventListener('load', this.update);
                image.addEventListener('error', this.update);
            });
        });

        if (document.fonts) {
            document.fonts.ready.then(this.update);
            document.fonts.addEventListener('loadingdone', this.update);
        }
    }

    update() {
        const animation = this.track.getAnimations().find(
            (entry) => entry.animationName === 'marquee'
        );

        if (animation && this.distance) {
            this.position = (
                Number(animation.currentTime || 0) / 1000 * this.speed
            ) % this.distance;
        }

        const originalWidth = this.items.reduce(
            (width, item) => width + item.offsetWidth,
            0
        );

        if (!originalWidth) {
            return;
        }

        const repetitions = Math.max(
            1,
            Math.ceil(this.viewport.clientWidth / originalWidth)
        );

        if (repetitions !== this.repetitions) {
            this.lists.forEach((list, listIndex) => {
                list.replaceChildren();

                for (let repetition = 0; repetition < repetitions; repetition++) {
                    this.items.forEach((item) => {
                        const isOriginal = listIndex === 0 && repetition === 0;
                        const entry = isOriginal
                            ? item
                            : item.cloneNode(true);

                        if (!isOriginal) {
                            entry.setAttribute('aria-hidden', 'true');
                            entry.classList.add('motion-reduce:hidden');
                        }

                        list.appendChild(entry);
                    });
                }
            });

            this.repetitions = repetitions;
        }

        const isStatic = this.reducedMotion.matches
            || document.activeElement === this.viewport;

        this.viewport.tabIndex = 0;
        this.viewport.classList.toggle('overflow-x-auto', isStatic);
        this.viewport.classList.toggle('overflow-hidden', !isStatic);
        this.lists[1].classList.toggle('hidden', isStatic);
        [...this.lists[0].children].forEach((item) => {
            const isClone = item.getAttribute('aria-hidden') === 'true';
            item.classList.toggle('hidden', isStatic && isClone);
        });
        if (isStatic) {
            this.track.classList.remove('animate-marquee');
            return;
        }

        this.viewport.scrollLeft = 0;
        this.distance = this.track.getBoundingClientRect().width / 2;
        this.track.style.animationDuration = `${this.distance / this.speed}s`;
        this.track.classList.add('animate-marquee');

        const currentAnimation = this.track.getAnimations().find(
            (entry) => entry.animationName === 'marquee'
        );

        if (currentAnimation) {
            currentAnimation.currentTime = (
                this.position % this.distance
            ) / this.speed * 1000;
        }
    }
}

MODULE.forEach((component) => {
    new ClientesSection(component);
});

export default ClientesSection;
